import { render, staticRenderFns } from "./Commissionlist.vue?vue&type=template&id=f9d28754"
import script from "./Commissionlist.vue?vue&type=script&lang=js"
export * from "./Commissionlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports